export const GET_CUSTOMERS_ERROR = "redux_store:customers.error.get";
export const GET_CUSTOMER_RESERVATIONS_ERROR = "redux_store:customers.error.get_reservations";
export const GET_CUSTOMER_DUPLICATES_ERROR = "redux_store:customers.error.get_duplicates";
export const ADD_CUSTOMER_ERROR = "redux_store:customers.error.post";
export const DELETE_CUSTOMER_ERROR = "redux_store:customers.error.delete";
export const BULK_DELETE_CUSTOMER_ERROR = "redux_store:customers.error.bulk_delete";
export const UPDATE_CUSTOMER_ERROR = "redux_store:customers.error.patch";
export const FUSE_CUSTOMERS_ERROR = "redux_store:customers.error.fuse";


// WEBPACK FOOTER //
// ./src/errors/customers.js